import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { updateSite, refreshReferential } from '../../app/updateApp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDiamondTurnRight } from '@fortawesome/pro-light-svg-icons';
import { faPhone, faSms } from '@fortawesome/pro-light-svg-icons';

const SiteGrid = () => {
    const { t } = useTranslation();

    useEffect(function () {
        refreshReferential().then(() => updateSite(siteState.selectedSite));
    }, []);

    const siteState = useSelector(state => state.sites);
    const usersState = useSelector(state => state.users);

    const currentSite = siteState.list.find(s =>
        s.id === siteState.selectedSite
    );

    const userTeamLeader = usersState.list.find(u => u.id === currentSite?.user_team_leader_id);
    const userResponsibleBusiness = usersState.list.find(u => u.id === currentSite?.user_responsible_business_id);
    const userWorksite = usersState.list.find(u => u.id === currentSite?.user_worksite_id);

    // Function to handle address click
    const handleAddressClick = () => {
        // Build complete address from all address fields
        const addressParts = [
            currentSite?.address,
            currentSite?.address_2,
            currentSite?.address_3,
            currentSite?.address_4,
            currentSite?.postal_code,
            currentSite?.city
        ].filter(part => part); // Remove empty/null/undefined parts
        
        const address = addressParts.join(', ');
        
        if (!address) return;
        
        // Encode the address for URL
        const encodedAddress = encodeURIComponent(address);
        
        // Detect device type
        const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
        const isAndroid = /Android/i.test(navigator.userAgent);
        
        if (isIOS) {
            // On iOS, use Apple Maps URL scheme
            const appleMapsUrl = `http://maps.apple.com/?q=${encodedAddress}`;
            window.location.href = appleMapsUrl;
        } else if (isAndroid) {
            // On Android, use geo: protocol which works well
            window.location.href = `geo:0,0?q=${encodedAddress}`;
        } else {
            // On desktop, open Google Maps in new tab
            const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
            window.open(googleMapsUrl, '_blank');
        }
    };

    return <div className='employee-grid' style={{marginBottom: '32px'}}>
        {currentSite ? (
            <>
                <div className="section-title with-icon">
                    <div className="icon" onClick={handleAddressClick} style={{ cursor: 'pointer' }} title="Ouvrir dans Maps">
                        <FontAwesomeIcon icon={faDiamondTurnRight} style={{ color: 'white', fontSize: '32px', marginBottom: '10px' }} />
                    </div>
                    <div>
                        Adresse <br />
                        <div className="section-value">
                            {currentSite.address ? <>{currentSite.address}<br/></> : undefined}
                            {currentSite.address_2 ? <>{currentSite.address_2}<br/></> : undefined}
                            {currentSite.address_3 ? <>{currentSite.address_3}<br/></> : undefined}
                            {currentSite.address_4 ? <>{currentSite.address_4}<br/></> : undefined}
                            {currentSite.postal_code ? <>{currentSite.postal_code} </> : undefined}
                            {currentSite.city ? <>{currentSite.city}</> : undefined}
                        </div>
                    </div>
                </div>
                <div className="section-title">Code<br /> <div className="section-value">{currentSite.code}</div></div>
                <div />
                <div className="section-title">Chef de chantier<br />  <div className="section-value">{currentSite.user_chef || '-'}</div></div>
                <div className="section-title">Contact sur chantier<br />  <div className="section-value">{currentSite.user_contact || '-'}</div></div>
                <div className="section-title">Conducteur de tvx<div className="section-value">{currentSite.user_ctvx || '-'}</div></div>
                <div className="section-title">
                    {currentSite.user_tel_contact ? (
                        <div className="section-value">
                            <div className="phone-actions">
                                <div className="phone-icons tel">
                                    <a href={`tel:${currentSite.user_tel_contact}`} className="phone-action-link" title="Appeler">
                                        <FontAwesomeIcon icon={faPhone} />
                                    </a>
                                </div>
                                <span className="phone-number">{currentSite.user_tel_contact.replace(/\./g, ' ')}</span>
                                <div className="phone-icons sms">
                                    <a href={`sms:${currentSite.user_tel_contact}`} className="phone-action-link" title="Envoyer un SMS">
                                        <FontAwesomeIcon icon={faSms} />
                                    </a>
                                </div>
                            </div>
                        </div>
                    ) : undefined}
                </div>
                <div className="section-title">
                    {currentSite.user_tel_ctvx ? (
                        <div className="section-value">
                            <div className="phone-actions">
                                <div className="phone-icons tel">
                                    <a href={`tel:${currentSite.user_tel_ctvx}`} className="phone-action-link" title="Appeler">
                                        <FontAwesomeIcon icon={faPhone} />
                                    </a>
                                </div>
                                <span className="phone-number">{currentSite.user_tel_ctvx.replace(/\./g, ' ')}</span>
                                <div className="phone-icons sms">
                                    <a href={`sms:${currentSite.user_tel_ctvx}`} className="phone-action-link" title="Envoyer un SMS">
                                        <FontAwesomeIcon icon={faSms} />
                                    </a>
                                </div>
                            </div>
                        </div>
                    ) : undefined}
                </div>
            </>
        ) : null }
    </div>;
};

export default SiteGrid;